<template>
  <b-table class="is-middle $white-bis" :loading="pageRead.loading" :data="pageRead.data"
    :current-page="pageRead.current_page" :per-page="pageRead.per_page" :total="pageRead.total"
    style="padding: 0;border: 1px solid #f2f2f2">
    <template slot-scope="props">
      <b-table-column label="Page number" custom-key="Page number" centered>
        <div>{{ props.row.page_number === 0 ? "cover" : props.row.page_number }}</div>
      </b-table-column>

      <b-table-column label="Read count" centered>
        <div>{{ readCount(props.row.read_pages_count) }}</div>
      </b-table-column>

      <b-table-column label="Average time spent" centered>
        <span class="has-text-grey">
          {{ createTime(props.row.avg_read_seconds) }}
        </span>
      </b-table-column>

      <b-table-column label="Total time spent" centered>
        <span class="has-text-grey">
          {{ createTime(props.row.tot_read_seconds) }}
        </span>
      </b-table-column>

      <b-table-column label="Last read at" centered>
        <b-tooltip :label="props.row.last_read_at | dateTime " v-if="props.row.last_read_at !== null">
          <span class="has-text-grey">
            {{ props.row.last_read_at | date }}
          </span>
        </b-tooltip>
        <span class="has-text-grey" v-else>-</span>
      </b-table-column>

      <b-table-column label="First read at" centered>
        <b-tooltip :label="props.row.first_read_at | dateTime " v-if="props.row.first_read_at !== null">
          <span class="has-text-grey">
            {{ props.row.first_read_at | date }}
          </span>
        </b-tooltip>
        <span class="has-text-grey" v-else>-</span>
      </b-table-column>
    </template>
    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>No view list.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>

export default {
  props: ['data-id', 'user-id'],
  data(props) {
    return {
      pageRead: new window.PaginatedRemoteCollection(
        `/admin/api/magazine/issues/${props.dataId}/page-read?user_id=${props.userId}&include_content_details=1`
      ).load()
    };
  },
  methods: {
    toggle(row) {
      this.$refs.table.toggleDetails(row)
    },

    createTime(time) {
      if (time === undefined) {
        return '-';
      }
      time = Math.round(time);
      let computedTime = 0;
      computedTime = time + " sec";
      if (time >= 60) {
        computedTime = Math.round(time / 60) + ' min ' + (time % 60) + " sec";
      }
      return computedTime;
    },
    readCount(times) {
      if (times === undefined) {
        return '-'
      }
      return times;
    }
  }
};
</script>
